import { render, staticRenderFns } from "./_Menu.vue?vue&type=template&id=656ae8da&scoped=true&"
import script from "./_Menu.vue?vue&type=script&lang=js&"
export * from "./_Menu.vue?vue&type=script&lang=js&"
import style0 from "./_Menu.vue?vue&type=style&index=0&id=656ae8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ae8da",
  null
  
)

export default component.exports